import RailsResource from './rails-resource';

export default new class extends RailsResource {
  constructor() {
    super({
      url: '/admin',
      resource: 'attendances',
      ajaxLoader: false
    })
  }

  confirm(id) {
    return this.post(`${this.url}/${this.resource}/${id}/confirm.json`, true);
  }

  reject(id) {
    return this.put(`${this.url}/${this.resource}/${id}/reject.json`, true);
  }
}